"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = queryProcedureResult;

var _config = _interopRequireDefault(require("../config"));

var _duck = require("../duck");

var _selectors = require("../duck/selectors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function runOtherCacheModificationLifecycle(dispatch, getState, proceduresToVisit) {
  Object.entries(proceduresToVisit).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        procedureName = _ref2[0],
        instructionsForCacheModifier = _ref2[1];

    var _config$getProcedure = _config.default.getProcedure(procedureName),
        cacheModifier = _config$getProcedure.cacheModifier;

    var cache = (0, _selectors.getProcedureCache)({
      procedureName: procedureName
    })(getState);

    function wrappedCacheModifier() {
      cache = cacheModifier({
        cache: cache
      }).apply(void 0, arguments);
    }

    instructionsForCacheModifier(wrappedCacheModifier);
    dispatch((0, _duck.updateProcedureCache)({
      procedureName: procedureName,
      updatedCache: cache
    }));
  });
}

function getIguazuDataOfCachedResult(getResultFromCache, cache, args) {
  var cachedResult;
  var getResultFromCacheError = null;

  try {
    cachedResult = getResultFromCache({
      cache: cache,
      args: args
    });
  } catch (err) {
    getResultFromCacheError = err;
  }

  if (getResultFromCacheError) {
    return null;
  }

  var resultIsInstanceOfError = cachedResult instanceof Error;
  return {
    data: resultIsInstanceOfError ? null : cachedResult,
    error: resultIsInstanceOfError ? cachedResult : null,
    status: 'complete',
    promise: Promise.resolve(cachedResult)
  };
}

function queryProcedureResult(_ref3) {
  var procedureName = _ref3.procedureName,
      args = _ref3.args,
      _ref3$forceFetch = _ref3.forceFetch,
      forceFetch = _ref3$forceFetch === void 0 ? false : _ref3$forceFetch;

  // lifecycle
  // getResultFromCache({ cache, args }) => result, or throws on cache misses
  // call(args) => result
  // buildUpdatedCache({ cache, args, result }) => updatedCache
  // cacheModifier({ cache }) => () => updatedCache
  // modifyOtherCaches({cache, args, result }) =>
  //   ({ otherProcedureA: (wrappedCacheModifier)=> wrappedCacheModifier() })
  var _config$getProcedure2 = _config.default.getProcedure(procedureName),
      getResultFromCache = _config$getProcedure2.getResultFromCache,
      call = _config$getProcedure2.call,
      buildUpdatedCache = _config$getProcedure2.buildUpdatedCache,
      modifyOtherCaches = _config$getProcedure2.modifyOtherCaches;

  return function (dispatch, getState) {
    var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        fetchClient = _ref4.fetchClient;

    if (!forceFetch) {
      var initialCache = (0, _selectors.getProcedureCache)({
        procedureName: procedureName
      })(getState);
      var iguazuDataOfCachedResult = getIguazuDataOfCachedResult(getResultFromCache, initialCache, args);

      if (iguazuDataOfCachedResult) {
        return iguazuDataOfCachedResult;
      }

      var existingCall = (0, _selectors.getStateOfExistingCall)({
        procedureName: procedureName,
        args: args
      })(getState);

      if (existingCall) {
        return existingCall.toJS();
      }
    }

    var callPromise = call({
      fetchClient: fetchClient || fetch,
      getState: getState,
      args: args
    });

    if (!(callPromise && typeof callPromise.then === 'function')) {
      var error = new Error("call function for ".concat(procedureName, " must return a Promise"));
      dispatch((0, _duck.finishLoadingWithError)({
        procedureName: procedureName,
        args: args,
        error: error
      }));
      throw error;
    }

    var promise = callPromise.then(function (result) {
      var cache = (0, _selectors.getProcedureCache)({
        procedureName: procedureName
      })(getState);
      var updatedCache = buildUpdatedCache({
        cache: cache,
        args: args,
        result: result
      });
      dispatch((0, _duck.updateProcedureCache)({
        procedureName: procedureName,
        updatedCache: updatedCache
      }));

      if (modifyOtherCaches) {
        runOtherCacheModificationLifecycle(dispatch, getState, modifyOtherCaches({
          cache: cache,
          args: args,
          result: result
        }));
      }

      dispatch((0, _duck.finishLoading)({
        procedureName: procedureName,
        args: args
      }));
      return updatedCache;
    }, function (error) {
      var cache = (0, _selectors.getProcedureCache)({
        procedureName: procedureName
      })(getState);
      var updatedCache = buildUpdatedCache({
        cache: cache,
        args: args,
        error: error
      });
      dispatch((0, _duck.updateProcedureCache)({
        procedureName: procedureName,
        updatedCache: updatedCache
      }));
      dispatch((0, _duck.finishLoadingWithError)({
        procedureName: procedureName,
        args: args,
        error: error
      }));
      return updatedCache;
    }).then(function (updatedCache) {
      var iguazuDataOfNewlyCachedResult = getIguazuDataOfCachedResult(getResultFromCache, updatedCache, args);

      if (iguazuDataOfNewlyCachedResult) {
        return iguazuDataOfNewlyCachedResult.promise;
      }

      throw new Error("".concat(procedureName, " did not cache the result/error from the call"));
    });
    dispatch((0, _duck.startLoading)({
      procedureName: procedureName,
      args: args,
      promise: promise
    }));
    return {
      promise: promise,
      status: 'loading'
    };
  };
}